import React from 'react';
import { GlobeIcon, InfinityIcon, ZapIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CTAButton } from '../CTAButton';
import { CountdownTimer } from '../CountdownTimer';
import { ScarcityBar } from '../ScarcityBar';
import { offerRows } from '../../data/content';
const guarantees = [{
  icon: ZapIcon,
  label: 'Instant digital access'
}, {
  icon: InfinityIcon,
  label: 'Lifetime access'
}, {
  icon: GlobeIcon,
  label: 'Automatic currency conversion'
}];
export function Offer() {
  return <section id="offer" className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-220" data-mp="3f2yyab68p5w1">
      <div className="mx-auto max-w-2xl" data-id="element-221" data-mp="3jwb99ihzxe6b">
        <SectionHeading eyebrow="The complete offer" title="Everything you need to turn renal uncertainty into a repeatable decision process" data-id="element-222" data-mp="3jxcw0k8djp3v" />

        <div className="mt-9 overflow-hidden rounded-3xl border border-navy-100 bg-white sm:mt-12" data-id="element-223" data-mp="3sxhu23rohb5d">
          <div className="flex items-center justify-between bg-navy-900 px-4 py-3 sm:px-6" data-id="element-224" data-mp="1q59rfvi0hl8">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-225" data-mp="1km9juxjprvqx">
              What you receive
            </p>
            <p className="text-[11px] font-extrabold uppercase tracking-[0.14em] text-navy-200" data-id="element-226" data-mp="1foq3ns3gh8wc">
              Value
            </p>
          </div>
          <ul data-id="element-227" data-mp="16mqluxkma0sc">
            {offerRows.map(row => <li key={row.label} className="flex items-start justify-between gap-4 border-b border-navy-100 px-4 py-3.5 sm:px-6" data-id="element-228" data-mp="23bya4dcmenzy">
                <span className="text-[14px] font-semibold leading-snug text-navy-800 sm:text-[15px]" data-id="element-229" data-mp="1zch49ita7ou9">
                  {row.label}
                </span>
                <span className="shrink-0 text-[14px] font-bold text-navy-400 line-through sm:text-[15px]" data-id="element-230" data-mp="1pji55705sfwe">
                  {row.value}
                </span>
              </li>)}
          </ul>
          <div className="flex items-center justify-between gap-4 px-4 py-4 sm:px-6" data-id="element-231" data-mp="2i8go26c3vm2r">
            <span className="text-[13px] font-extrabold uppercase tracking-wide text-navy-900 sm:text-sm" data-id="element-232" data-mp="3157h8pvs1os1">
              Total value
            </span>
            <span className="font-display text-xl font-bold text-navy-900 sm:text-2xl" data-id="element-233" data-mp="366emoiag6bvj">$292</span>
          </div>

          <div className="border-t-2 border-dashed border-navy-100 bg-navy-900 px-5 py-8 text-center sm:px-8 sm:py-10" data-id="element-234" data-mp="2wer0avsqzl0x">
            <p className="text-[12px] font-bold uppercase tracking-[0.14em] text-navy-200 sm:text-[13px]" data-id="element-235" data-mp="2ieg5xis8bob0">
              Total value $292 — today just
            </p>
            <p className="mt-2 font-display text-[64px] font-bold leading-none text-white sm:text-7xl" data-id="element-236" data-mp="2nbpwx2v9o80y">
              $27
            </p>
            <p className="mt-3 text-[14px] font-medium leading-relaxed text-navy-100 sm:text-[15px]" data-id="element-237" data-mp="2df4qqe7igqvj">
              You don’t pay $292. You don’t pay $97. One-time payment. No subscription. No recurring
              charges.
            </p>

            <ul className="mx-auto mt-6 flex max-w-sm flex-col gap-2" data-id="element-238" data-mp="bnqhahuospgl">
              {guarantees.map(item => <li key={item.label} className="flex items-center justify-center gap-2 rounded-xl bg-white/10 px-3 py-2.5 text-[13px] font-bold text-white sm:text-[14px]" data-id="element-239" data-mp="1w47rgoi3jj74">
                  <item.icon className="h-4 w-4 shrink-0 text-brick-400" aria-hidden="true" data-id="element-240" data-mp="2155bl6mo2nb9" />
                  {item.label}
                </li>)}
            </ul>
            <p className="mx-auto mt-3 max-w-sm text-[12.5px] font-medium leading-relaxed text-navy-200" data-id="element-241" data-mp="2avgr7qfpqkxz">
              Currency conversion is automatic — you pay the equivalent of $27 in your local currency
              at checkout.
            </p>
          </div>
        </div>

        <div className="mt-8" data-id="element-242" data-mp="2ju24p76bv9rw">
          <CTAButton label="Yes — I want Kidney Disease Route™" subline="Get the complete system for $27 • Instant access • Lifetime" data-id="element-243" data-mp="ugyn8wnyrcs9" />
        </div>

        <div className="mt-6" data-id="element-244" data-mp="rwsl8uiwtwec">
          <CountdownTimer data-id="element-245" data-mp="rxk5xaayy9pu" />
        </div>

        <div className="mt-6" data-id="element-246" data-mp="rwiw195ovt9p">
          <ScarcityBar data-id="element-247" data-mp="vydw6abvw0lw" />
        </div>
      </div>
    </section>;
}